import styled from 'styled-components';

interface ContainerProps {
  isDarkMode: boolean;
}

export const FilterContainer = styled.div<ContainerProps>`
  background-color: ${(props) =>
    props.isDarkMode ? '#262626' : '#ffffff'};
  border: 1px solid ${(props) =>
    props.isDarkMode ? '#434343' : '#d9d9d9'};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DesktopLayout = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const TabletLayout = styled.div`
  display: none;

  @media (min-width: 768px) and (max-width: 1023px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const MobileLayout = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 2;
  min-width: 200px;

  @media (max-width: 1023px) {
    flex: 1;
    min-width: unset;
  }
`;

export const FilterSelectWrapper = styled.div`
  flex: 1;
  min-width: 150px;

  @media (max-width: 1023px) {
    flex: 1;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const SelectsRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const SelectGroup = styled.div`
  flex: 1;
  min-width: 150px;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ClearButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const ClearButton = styled.button<ContainerProps>`
  padding: 6px 12px;
  background-color: transparent;
  border: 1px solid ${(props) =>
    props.isDarkMode ? '#434343' : '#d9d9d9'};
  border-radius: 4px;
  color: ${(props) => (props.isDarkMode ? '#d9d9d9' : '#666666')};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
      props.isDarkMode ? '#434343' : '#f5f5f5'};
    border-color: ${(props) =>
      props.isDarkMode ? '#595959' : '#999999'};
    color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 767px) {
    padding: 6px 10px;
    font-size: 13px;
  }
`;
